import React from "react";
import { useSelector } from "react-redux";

import { settingSelectors } from "../../settings/_core/settingSelectors";
import {
  DefaultNotAvailableForAddressComponent,
  DefaultNotInStockComponent,
  ProductQuantity
} from "../productQuantity/ProductQuantity";


export const RollProductComponent = ({product, handleRemoveItem, handleAddItem, count}) => {
	const settings = useSelector(settingSelectors.settings);

	if (settings.baskedDisabled) {
		return null;
	}

	if (!product.isOnTrade) {
		return (<DefaultNotInStockComponent />);
	}

	if (!product.isSuitableForCurrentCart) {
		return (<DefaultNotAvailableForAddressComponent />);
	}

	return (
		<div className="main-goods-quantity">
			<button className="main-goods-quantity__controls"
							data-button-type="minus"
							onClick={handleRemoveItem}>–
			</button>
			<strong className="main-goods-quantity__numbers">{count}</strong>
			<button className="main-goods-quantity__controls"
							data-button-type="plus"
							onClick={handleAddItem}>+
			</button>
		</div>
	)
};

export const RollProductQuantity = (props) => {
	return (
		<ProductQuantity {...props}>
			<RollProductComponent product={props.product}/>
		</ProductQuantity>
	)
};
